module.exports = __webpack_public_path__ + "img/kreis-ausgewaehlt.b8b06a24.svg";